export const BookingPageTypeConst = {
  Contractor: '一般',
  Partner: '合作廠商',
} as const;

export const BookingListTypeConst = {
  Reserve: '預約清單',
  History: '歷史資料',
} as const;

export const JanitorKind = {
  Contractor: 'Contractor',
  Partner: 'Partner',
} as const;

export const bookingListAPIUrl = '/ezcon/api/fetchBookingList';
export const reservationRulesAPIUrl = '/ezcon/api/fetchReservationRule';
